import axios from "axios";

export default {
  namespaced: true,
  state: {
    glposts: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    glpostsMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
      state.isDeleting = false;
    },
    RECEIVED_GLPOSTS(state, payload) {
      state.glposts = payload;
      state.isReceiving = false;
    },
    RECEIVING_GLPOSTS(state) {
      state.isReceiving = true;
    },
    RECEIVED_GLPOST(state, payload) {
      if(payload==null) state.isReceiving = false;
      else{
        state = Object.assign(state, {
          glposts: [...state.glposts, payload],
          isReceiving: false,
        })
      }
    },
    RECEIVING_GLPOST(state) {
      state.isReceiving = true;
    },
    UPDATED_GLPOST(state, payload) {
      let index = state.glposts.findIndex(glpost => glpost._id === payload._id);
      state = Object.assign(state, {
        glposts: state.glposts.map((glpost, i) => {
          if (i === index) {
            return Object.assign({}, glpost, payload);
          }
          return glpost;
        }),
        isUpdating: false,
        glpostsMessage: 'GLPosts has been updating!',
      })
    },
    UPDATING_GLPOST(state) {
      state.isUpdating = true;
    },
    DELETED_GLPOST(state, payload) {
      let indexToDelete = state.glposts.findIndex(glpost => glpost._id === payload._id);
      let glposts = [...state.glposts];
      glposts.splice(indexToDelete, 1);
      state = Object.assign(state, {
        glposts: [...glposts],
        isDeleting: false,
        idToDelete: null,
        glpostsMessage: 'GLPost has been Deleted!',
      });
    },
    DELETING_GLPOST(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async getGLPostsRequest({dispatch}) {
      dispatch("receivingGLPosts");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/gl-posts';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "GET", url: url, headers: headers})
      .then(res => {
        dispatch("receiveGLPosts", res.data);
      })
    },
    async updateGLPostRequest({dispatch}, payload) {
      dispatch("updatingGLPost");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/gl-post/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      return axios({method: "PUT",url: url,headers: headers,data: payload})
      .then(function (res) {
        dispatch("updateGLPost", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    async updateGLPostTransaction({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/update/gl-transaction/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("doNothing");
        return response.data;
      }
      catch(e){
        console.log(e)
        return null;
      }
    },
    async updateGLPostSendRequest({dispatch}, payload) {
      dispatch("updatingGLPost");
      var id = payload._id;
      delete payload['_id'];
      var token = localStorage.getItem('token');
      var url = 'https://api.accountxc.com:3100/update/gl-post/send/' + id;
      var header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      let response = await axios({method:"put", url:url, headers:header, data:payload})
      dispatch("updateGLPost", response.data);
      return response.data;
    },
    async insertGLPostRequest({dispatch}, payload) {
      dispatch("receivingGLPosts");
      let token = localStorage.getItem('token');
      console.log(token)
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let url = 'https://api.accountxc.com:3100/insert/gl-post';
      let data = payload;
      console.log(data);
      return axios({method: "POST", url: url, headers: headers, data: data})
      .then((response)=>{
        dispatch("receiveGLPost", response.data);
      })
      .catch((error) => {
        dispatch("doNothing");
        this.alertmessage = error;
      });	
    },
    deleteGLPostRequest({dispatch}, payload) {
      dispatch("deletingGLPost", payload);
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/delete/gl-post/' + payload._id
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "DELETE", url: url, headers: headers})
      .then((response) => {
        dispatch("deleteGLPost", response.data);
      })
      .catch((error) => {
        console.log('error', error)
        dispatch("doNothing");
        this.alertmessage = error;
      });	
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    receiveGLPosts({commit}, payload) {
      commit("RECEIVED_GLPOSTS", payload)
    },
    receivingGLPosts({commit}) {
      commit("RECEIVING_GLPOSTS")
    },
    receiveGLPost({commit}, payload) {
      commit("RECEIVED_GLPOST", payload)
    },
    receivingGLPost({commit}) {
      commit("RECEIVING_GLPOST")
    },
    updateGLPost({commit}, payload) {
      commit("UPDATED_GLPOST", payload)
    },
    updatingGLPost({commit}) {
      commit("UPDATING_GLPOST")
    },
    deleteGLPost({commit}, payload) {
      commit("DELETED_GLPOST", payload)
    },
    deletingGLPost({commit}, payload) {
      commit("DELETING_GLPOST", payload)
    }
  },
};
